import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useProfileStore } from '../../store/profileStore';
import { SleepGuide } from './steps/SleepGuide';
import { StrainGuide } from './steps/StrainGuide';
import { RecoveryGuide } from './steps/RecoveryGuide';
import { FinalStep } from './steps/FinalStep';

export function OnboardingFlow() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const { setHasSelectedProfile } = useProfileStore();

  const steps = [
    {
      id: 'sleep',
      component: SleepGuide
    },
    {
      id: 'strain',
      component: StrainGuide
    },
    {
      id: 'recovery',
      component: RecoveryGuide
    },
    {
      id: 'final',
      component: FinalStep
    }
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(prev => prev + 1);
    } else {
      setHasSelectedProfile(true);
      navigate('/home');
    }
  };

  const CurrentStep = steps[step].component;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <AnimatePresence mode="wait">
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            <CurrentStep onNext={handleNext} />
          </motion.div>
        </AnimatePresence>

        {/* Progress Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === step
                  ? 'bg-primary'
                  : index < step
                  ? 'bg-primary/50'
                  : 'bg-muted'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}